require("./material.js");
require("./ripples.js");


// WEBPACK FOOTER //
// ../patched_modules/bootstrap-material-design/scripts/index.js